//helper
import Account from '@/helper/AccountHelper.js';
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/Locale.js';
import { CampaignType } from "@/helper/StaticValue.js";
//config
import {
    RedeemConfigBuilder,
    RedeemShippingAddressConfigBuilder
} from '@/core/Redeem/config/RedeemConfigBuilder.js';
//model
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
import { WebInterfaceController } from './WebInterfaceController';
//service
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import { DrawDeliveryModel } from '@/core/Redeem/model/DrawDeliveryModel.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';

/**
 * event
 * @method onRedeemSuccess
 * @method onErrorApi
 * @method onRedirect
 */
export function RedeemController () {
    this.lbl = Locale.getLbl();
    this.localeCode = Locale.getLocaleCode();
    this.cacheHelper = new CacheHelper(ConfigManager.getCacheType());

    this.campaign = {};
    this.selectedCampaignId = null;
    this.selectedQuantity = null;

    this.redeemConfigBuilder = new RedeemConfigBuilder();
    this.modalController = null;

    this.tracking = null;


    //#region initial
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     * @param {ModalController} modalController /components/Modal/ModalController.js
     */
    this.initial = (campaign, modalController, tracking) => {
        this.campaign = campaign;
        this.modalController = modalController;

        this.tracking = tracking;
    };
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.reinitial = (campaign) => {
        this.lbl = Locale.getLbl();
        this.campaign = campaign;
    }
    //#endregion initial

    //#region redeem
    /**
     * Click ปุ่ม Redeem แล้วจะเรียกที่นี่
     *      - show popup confirm
     * @param {Number} selectedCampaignId campaign id
     * @param {Number} selectedQuantity quanty
     */
    this.clickRedeem = (selectedCampaignId, selectedQuantity) => {
        if (!this.onClickRedeem()) {
            return;
        }

        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;

        if (this.campaign.type == CampaignType.Interface) {
            if (this.campaign.website.indexOf('survey') >= 0) {
                this.confirmRedeem();
            } else
                this.modalController.confirmRedeemModal
                                    .clearModal()
                                    .setCampaign(this.campaign)
                                    .show()

                this.modalController.confirmRedeemModal.onClickOk(() => {
                    // event confirm redeem
                    if (!this.onConfirmRedeem()) {
                        return;
                    }
                    this.confirmRedeem();
                });

                this.modalController.confirmRedeemModal.onClickCancel(() => {
                    // event cancel redeem
                    this.onCancelRedeem();
                });
        } else if(this.campaign.type == CampaignType.PayWithPoint) {
            this.confirmRedeem();
        } else {
            this.modalController.confirmRedeemModal
            .clearModal()
            .setCampaign(this.campaign)
            .show()

            this.modalController.confirmRedeemModal.onClickOk(() => {
                // event confirm redeem
                if (!this.onConfirmRedeem()) {
                return;
                }
                this.confirmRedeem();
            });

            this.modalController.confirmRedeemModal.onClickCancel(() => {
                // event cancel redeem
                this.onCancelRedeem();
            });
        }
    };

    /**
     * * Click popup Confirm Redeem แล้วจะเรียกที่นี่
     */
    this.confirmRedeem = () => {
        //% Open web Campaign Type 8
        if (this.isCampaignTypeInterFace()) {
            if (!this.onOpenInterface()) {
                return;
            }

            this.openWebInterface();
        }

        //% Open web Survey
        else if (this.isCampaignTypeSurvey()) {
            this.openWebInterface();
        }

        //% ไม่รู้คืออะไร เขียนไว้กันลืม
        else if (this.isCampaignTypeApi()) {
            this.onOpenInterface();
        }

        //% Add item to cart
        else if (this.isCampaignTypeBuy()) {
            if (!this.onAddToCart()) {
                return;
            }
            this.addToCart();
        }

        // privilege 2.0
        else if (this.campaign.type == CampaignType.Privilege2) {
            this.addToCart('isClearCart');
        }
        //% Open modal shipping
        else if (this.campaign.delivered) {
            if (!this.onOpenShipping()) {
                return;
            }

            this.openDeliveryCampaign();
        }

        else if (this.isCampaignTypePayWithPoint()){
            this.openWebPayWithPoint();
        }

        //% Normal Redeem
        else {
            if (!this.onRedeem()) {
                return;
            }
            this.redeem();
        }
    };

    /**
     * * Redeem delivery open shipping address
     */
    this.openDeliveryCampaign = function() {
        if (ConfigManager.getAddressType() == "profile") {
            this.modalController.shippingAddressModal
                .clearModal()
                .setTitle(this.lbl.shipping.headline1)
                .show();

            this.modalController.shippingAddressModal.onSaveAddress(address => {
                if (!this.onSaveShipping()) {
                    return;
                }
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = address;
                this.redeem();
            });
        } else if (ConfigManager.getAddressType() == "addressList") {
            this.modalController.listAddressModal
                    .setNotShowModalAfterUpdate()
                    .show();
            this.modalController.listAddressModal.onUpdateSuccess((address) => {
                if (!this.onSaveShipping()) {
                    return;
                }
                let addressBuilder = new RedeemShippingAddressConfigBuilder();
                addressBuilder.setAddressFromDeliveryAddressModel(address);
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = addressBuilder;
                this.redeem();
            });
        } else {
            console.log("มึงเขียนคอนฟิก Shipping Address ผิด");
        }
    };

    /**
     * * Call api Redeem
     */
    this.redeem = () => {
        let params = this.redeemConfigBuilder.getRedeemParams();
        this.modalController.loadingModal.show();
        BzbsRedeem.apiRedeemCampaign(this.selectedCampaignId, params, this.selectedQuantity)
            .subscribe((campaign) => {
                this.modalController.loadingModal.hide();
                this.campaign.updateAfterRedeem(campaign);

                this.initialSerial();
                this.onRedeemSuccess(campaign);
            }, (err) => {
                this.modalController.loadingModal.hide();
                this.onRedeemError(err);
            });
    };
    //#endregion redeem

    //#region interface redeem open web
    this.openWebInterface = function() {
        let webInterface = new WebInterfaceController(this.campaign);
        webInterface.openInterface();
    };
    this.openWebPayWithPoint = () => {
        if (this.campaign.website == null) return ;
        let urlPayWithPoint = this.campaign.website
        let campaignId = this.campaign.id
        let theme = ConfigManager.getAppName();
        let appId = ConfigManager.getAppId();
        let suffledToken = Account.getTokenShuffle();
        let returnUrl = window.location.href + '?back=-1';

        let url = urlPayWithPoint
            + '?campaign_id=' + campaignId
            + '&app_id=' + appId
            + '&theme=' + theme
            + '&locale=' + this.localeCode
            + '&token=' + suffledToken
            + '&return_url=' + encodeURIComponent(returnUrl);
        window.location = url;
    }
    //#endregion interface redeem open web

    //#region buy
    this.addToCart = (isClearCart) => {
        let cartItem = new AddCartModel();
        let cartParams = cartItem.addItem(this.selectedCampaignId, this.selectedQuantity)

        // privilege 2.0
        if (isClearCart) {
            cartParams = cartItem.setClearCart(true);
        }
        cartParams = cartItem.getParams();

        this.modalController.loadingModal.show();
        BzbsCart.apiAddToCart(cartParams).subscribe((data) => {
            console.log(data);
            this.modalController.loadingModal.hide();
            this.BuyRedirect();
        }, (err) => {
            this.modalController.loadingModal.hide();
            this.onAddToCartError(err);
        });
    };
    this.BuyRedirect = () => {
        if (this.campaign.type == CampaignType.Privilege2) {
            //privilege 2.0
            this.openWebPrivilege();
        }else{
            this.onAddToCartSuccess();
        }
    };
    //privilege 2.0
    this.openWebPrivilege = function() {
        //TODO: Setup link
        let webUrl = this.campaign.website;
        //var theme = ConfigManager.getAppName();
        let theme = 'ecommerce_brand_a';
        let suffledToken = Account.getTokenShuffle();
        let api = ConfigManager.getApi();
        let brand = ConfigManager.getAppName();
        let returnUrl = encodeURIComponent(window.location.href) + '?back=' + -1;
        let successUrl = encodeURIComponent(window.location.origin)+ '/home';
        let strLocale = Locale.getLocaleCode();
        let appid = ConfigManager.getAppId();
        let multilang = true;

        webUrl = ConfigManager.getShoppingCartUrl() + "/marketplaceprivilege?"
            + "token=" + suffledToken
            + "&return_url=" + returnUrl
            + "&success_url=" + successUrl
            + "&theme=" + theme
            + "&appid=" + appid
            + "&brand=" + brand.toLowerCase()
            + "&multilang=" + multilang
            + "&api=" + api
            + "&locale=" + strLocale;

        window.location.href = webUrl;
    };
    //#endregion buy

    //#region serial
    this.initialSerial = () => {
        if (this.campaign.delivered || this.campaign.type == CampaignType.Draw) {
            let drawDelivery = new DrawDeliveryModel();
            console.log(drawDelivery);
            drawDelivery.setModelFromDataModel(this.campaign);
            this.modalController.drawDeliveryModal
                .setDrawDelivery(drawDelivery)
                .show();
        } else {
            this.tracking.event('privilege_detail', 'view_code', this.campaign.id + '|' + this.campaign.name);

            let serial = new SerialModel();
            serial.setModelFromDataModelCampaign(this.campaign);
            this.modalController.serialModal
                .setSerial(serial)
                .show();

            this.modalController.serialModal.onCloseModal(data => {
                this.tracking.event('privilege_detail', 'close_close', this.campaign.id + '|' + this.campaign.name);
                console.log(data);
                window.location.reload();
            });
            this.modalController.serialModal.onSerialExpire(data => {
                console.log(data);
            });
            this.modalController.serialModal.onClickUse(()=> {
                BzbsHistory.apiRedeemUse(this.campaign.redeemKey).subscribe((result) => {
                    this.campaign.updateAfterRedeem(result);
                    this.openSerial();
                    // TODO ถ้ามีไรแปลกๆ ก็เปิด comment นี้ได้ (Chat)

                }, (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                });
            });
        }
    };
    this.openSerial = () => {
        let serial = new SerialModel();
        serial.setModelFromDataModel(this.campaign);
        serial.setUse();
        if (serial.showTimer && serial.expireIn != 0) {
            this.modalController.serialModal
                .setSerial(serial)
                .show();
            this.modalController.serialModal.onCloseModal(data => {
                this.tracking.event('privilege_detail', 'close_close', this.campaign.id);
                console.log(data);
                window.location.reload();
            });
            this.modalController.serialModal.onSerialExpire(data => {
                console.log(data);
            });
        } else {
            this.modalController.serialModal.hide();
            window.location.reload();
        }
    }
    //#endregion serial

    //#region event
    this.onClickRedeem = () => true;
    this.onConfirmRedeem = () => true;
    this.onCancelRedeem = () => true;
    this.onOpenInterface = () => true;
    this.onOpenShipping = () => true;
    this.onSaveShipping = () => true;
    this.onRedeem = () => true;
    this.onRedeemSuccess = () => true;
    this.onRedeemError = () => true;
    this.onAddToCart = () => true;
    this.onAddToCartSuccess = () => true;
    this.onAddToCartError = () => true;
    //#endregion event

    //#region private function
    this.isCampaignTypeInterFace = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'web');
    };
    this.isCampaignTypeSurvey = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'survey' || this.campaign.interfaceDisplay == 'surveyapprove');
    };
    this.isCampaignTypeApi = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'api');
    };
    this.isCampaignTypeBuy = function() {
        return (this.campaign.type == CampaignType.Buy);
    };
    this.isCampaignTypePayWithPoint = function() {
        return (this.campaign.type == CampaignType.PayWithPoint);
    };
    //#endregion private function
}
